import { RootState } from '../../store';

export const selectUserState = (state: RootState) => state.user;
